<div class="td-wrap">

  <a href="javascript:;" class="td-back" (click)="back()"><i class="fa fa-arrow-left"></i> Kembali ke daftar grup</a>

  <!-- ===== header ===== -->
  <div class="td-card td-hero" *ngIf="isHeaderLoading">
    <div class="vl-loading"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
    <div style="min-height: 120px"></div>
  </div>

  <div class="td-card td-empty" *ngIf="notFound && !isHeaderLoading">
    <i class="fa fa-search"></i>
    <h3>Grup tidak ditemukan</h3>
    <p>Grup dengan ID {{id}} tidak ada di database.</p>
  </div>

  <ng-container *ngIf="group">
    <!-- hero: identity + facts on top, the current-cycle snapshot as a stat strip below -->
    <div class="td-card td-hero">
      <div class="td-hero-top">
        <div class="td-photo-wrap">
          <img *ngIf="group.photoUrl" [src]="group.photoUrl" alt="{{group.name}}" class="td-photo vb-click" title="Lihat foto"
               (click)="openViewer(group.photoUrl)" onerror="this.onerror=null;this.style.display='none';">
          <span *ngIf="!group.photoUrl" class="td-photo td-photo-ph"><i class="fa fa-book-open"></i></span>
        </div>
        <div class="td-hero-main">
          <div class="td-title-row">
            <h2>{{group.name}}</h2>
            <span class="vl-pill" [class.on]="group.status == 'active'" [class.off]="group.status == 'idle'" [class.del]="group.status == 'deleted'">
              <span class="vl-dot"></span>{{statusLabel(group.status)}}</span>
            <span class="td-chip">Khatam ke-{{group.current_cycle}}</span>
            <span class="td-chip gold" *ngIf="group.is_khatam_complete" title="Siklus ini sudah mencapai akhir mushaf"><i class="fa fa-flag-checkered"></i> Khatam tercapai</span>
          </div>
          <p class="td-desc" *ngIf="group.description">{{group.description}}</p>
          <p class="td-desc vl-muted" *ngIf="!group.description">Tidak ada deskripsi grup.</p>
          <div class="td-notice" *ngIf="group.deleted_at"><i class="fa fa-trash"></i> Grup dihapus pada {{group.deletedVw}} &mdash; riwayat tetap tersimpan dan bisa dipantau.</div>
        </div>
        <span class="tl-readonly" *ngIf="!canDelete" title="Halaman ini hanya untuk memantau"><i class="fa fa-eye"></i> Hanya lihat</span>
        <button type="button" class="td-del-btn" *ngIf="canDelete && !group.deleted_at" (click)="askDeleteGroup()"
                title="Hapus grup (khusus Super Admin)"><i class="fa fa-trash"></i> Hapus Grup</button>
      </div>

      <div class="td-facts">
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-user"></i></span>
          <span class="td-fact-body">
            <span class="td-fact-l">Pemilik</span>
            <span class="td-fact-v td-owner">
              <img [src]="group.ownerPhotoUrl || 'assets/images/no_avatar.webp'" alt="" class="td-avatar" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
              <span>{{group.owner_name || '—'}}</span>
            </span>
          </span>
        </div>
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-calendar"></i></span>
          <span class="td-fact-body"><span class="td-fact-l">Dibuat</span><span class="td-fact-v">{{group.createdVw}}</span></span>
        </div>
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-book-open"></i></span>
          <span class="td-fact-body"><span class="td-fact-l">Target bacaan</span><span class="td-fact-v">{{group.targetVw}} <span class="vl-muted">&middot; mulai {{group.start_surah_name}}</span></span></span>
        </div>
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-users"></i></span>
          <span class="td-fact-body"><span class="td-fact-l">Berlaku untuk</span><span class="td-fact-v">{{group.scopeVw}}</span></span>
        </div>
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-check-square"></i></span>
          <span class="td-fact-body"><span class="td-fact-l">Cara mencatat bacaan</span><span class="td-fact-v">{{group.recordVw}}</span></span>
        </div>
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-clock"></i></span>
          <span class="td-fact-body"><span class="td-fact-l">Aktivitas terakhir</span><span class="td-fact-v">{{group.lastActivityVw}}</span></span>
        </div>
      </div>

      <div class="td-stats">
        <div class="td-stat">
          <span class="td-label">Anggota Aktif</span>
          <span class="td-num">{{formatNumber(group.member_count)}}</span>
          <span class="td-kpi-foot">{{formatNumber(group.admin_count)}} admin<ng-container *ngIf="group.pending_count"> &middot; {{formatNumber(group.pending_count)}} menunggu</ng-container></span>
        </div>
        <div class="td-stat">
          <span class="td-label">Tugas Bacaan</span>
          <span class="td-num" *ngIf="group.current_days">{{turnTag(formatNumber(group.current_day), false)}}</span>
          <span class="td-num td-num-sm" *ngIf="!group.current_days">Belum mulai</span>
          <span class="td-kpi-foot">{{formatNumber(group.current_days)}} tugas di khatam ke-{{group.current_cycle}} &middot; per {{group.periodUnit}}</span>
        </div>
        <div class="td-stat">
          <span class="td-label">Posisi Bacaan</span>
          <span class="td-num" *ngIf="group.current_juz">Juz {{group.current_juz}}</span>
          <span class="td-num td-num-sm" *ngIf="!group.current_juz">&mdash;</span>
          <span class="td-kpi-foot" *ngIf="group.progress">tuntas bersama sampai juz {{group.progress.frontier_juz || 0}}</span>
        </div>
        <div class="td-stat">
          <span class="td-label">Bagian Selesai</span>
          <span class="td-num" *ngIf="group.progress && group.progress.parts_total">{{group.progress.pct}}<span class="td-num-of">%</span></span>
          <span class="td-num td-num-sm" *ngIf="!group.progress || !group.progress.parts_total">&mdash;</span>
          <span class="td-kpi-foot" *ngIf="group.progress">
            <span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="group.progress.pct"></span></span>
            {{formatNumber(group.progress.parts_done)}}/{{formatNumber(group.progress.parts_total)}} bagian
            <ng-container *ngIf="group.today_total"> &middot; {{group.currentTurnVw}} {{group.today_done}}/{{group.today_total}}</ng-container>
          </span>
        </div>
      </div>
    </div>

    <!-- ===== tabs ===== -->
    <div class="card">
      <div class="card-body">
        <div class="td-tabs" role="tablist">
          <button *ngFor="let t of tabs" type="button" role="tab" class="td-tab" [class.on]="tab == t.key"
                  [attr.aria-selected]="tab == t.key" (click)="openTab(t.key)">{{t.label}}</button>
        </div>

        <!-- ---------- ANGGOTA ---------- -->
        <div class="vl-card" *ngIf="tab == 'members'">
          <div class="vl-loading" *ngIf="loading.members"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <div class="td-subbar">
            <div class="tl-seg" role="tablist" aria-label="Filter status anggota">
              <button type="button" [class.on]="memberFilter == ''" (click)="memberFilter = ''">Semua <b>{{memberCount('')}}</b></button>
              <button type="button" [class.on]="memberFilter == '1'" (click)="memberFilter = '1'">Aktif <b>{{memberCount('1')}}</b></button>
              <button type="button" [class.on]="memberFilter == '0'" (click)="memberFilter = '0'">Undangan <b>{{memberCount('0')}}</b></button>
              <button type="button" [class.on]="memberFilter == '3'" (click)="memberFilter = '3'">Minta gabung <b>{{memberCount('3')}}</b></button>
              <button type="button" [class.on]="memberFilter == '2'" (click)="memberFilter = '2'">Dikeluarkan <b>{{memberCount('2')}}</b></button>
            </div>
            <div class="vl-spacer"></div>
            <span class="vl-muted vl-small">Partisipasi dihitung pada khatam ke-{{group.current_cycle}}</span>
          </div>
          <div class="vl-scroll">
          <table class="vl-table">
            <thead><tr>
              <th class="vl-num">No</th><th>Anggota</th><th>Peran</th><th>Status</th><th>Bergabung</th>
              <th>Partisipasi</th><th>Terakhir Selesai</th><th class="text-center">Belum Dibaca</th>
              <th *ngIf="canDelete" class="td-act-col"></th>
            </tr></thead>
            <tbody>
            <tr *ngFor="let m of visibleMembers; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1" [class.td-dim]="m.status == 2">
              <th class="vl-num">{{i + 1}}</th>
              <td>
                <div class="tl-ident">
                  <img [src]="m.photoUrl || 'assets/images/no_avatar.webp'" alt="" class="td-avatar-md vb-click" (click)="openViewer(m.photoUrl)"
                       onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                  <div class="tl-ident-text">
                    <span class="vl-name">{{m.nameVw}}</span>
                    <span class="tl-desc" *ngIf="m.email">{{m.email}}</span>
                  </div>
                </div>
              </td>
              <td><span class="vl-tag" [class.owner]="m.is_owner" [class.admin]="!m.is_owner && m.role == 1" [class.member]="!m.is_owner && m.role != 1">{{roleLabel(m)}}</span></td>
              <td><span class="vl-pill" [ngClass]="memberStatusClass(m.status)"><span class="vl-dot"></span>{{memberStatusLabel(m.status)}}</span></td>
              <td class="vl-muted">{{m.joinedVw}}</td>
              <td>
                <ng-container *ngIf="m.parts_total">
                  <div class="td-part"><span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="m.pct"></span></span><span>{{m.parts_done}}/{{m.parts_total}} <span class="vl-muted">({{m.pct}}%)</span></span></div>
                </ng-container>
                <span class="vl-muted" *ngIf="!m.parts_total">Belum ada bagian</span>
              </td>
              <td><span [title]="m.lastDoneFull">{{m.lastDoneVw}}</span></td>
              <td class="text-center"><span *ngIf="m.status == 1" [class.td-unread]="m.unread_count > 0">{{formatNumber(m.unread_count)}}</span><span class="vl-muted" *ngIf="m.status != 1">&mdash;</span></td>
              <td *ngIf="canDelete" class="td-act-col">
                <button type="button" class="td-del" *ngIf="!m.is_owner && m.status != 2 && !group.deleted_at" (click)="askDeleteMember(m)"
                        [title]="m.status == 1 ? 'Keluarkan dari grup' : 'Hapus undangan / permintaan'"><i class="fa fa-user-times"></i></button>
              </td>
            </tr>
            <tr *ngIf="!visibleMembers.length && !loading.members"><td [attr.colspan]="canDelete ? 9 : 8" class="vl-empty">Tidak ada anggota pada filter ini</td></tr>
            </tbody>
          </table>
          </div>
        </div>

        <!-- ---------- PERCAKAPAN (mirrors the app's chat list) ---------- -->
        <div class="vl-card" *ngIf="tab == 'chats'">
          <div class="vl-loading" *ngIf="chatsLoading"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <div class="td-subbar">
            <span class="vl-muted vl-small"><i class="fa fa-eye"></i> Tampilan sama seperti di aplikasi &mdash; admin hanya membaca, tidak bisa membalas.</span>
            <div class="vl-spacer"></div>
            <span class="vl-muted vl-small">{{formatNumber(chats.length)}} dari {{formatNumber(chatsTotal)}} pesan dimuat</span>
          </div>
          <div class="tc-scroll">
            <div class="tc-older" *ngIf="chatsHasMore()">
              <button type="button" class="tc-older-btn" [disabled]="chatsOlderLoading" (click)="loadChats(true)">
                <i class="fa" [ngClass]="chatsOlderLoading ? 'fa-spinner fa-spin' : 'fa-history'"></i>
                Muat pesan lebih lama ({{formatNumber(chatsRemaining())}} lagi)
              </button>
            </div>

            <ng-container *ngFor="let c of chats">
              <div class="tc-date" *ngIf="c.showDate"><span>{{c.dayLabel}}</span></div>

              <!-- member bubble / deleted bubble (left side; admin is never the sender) -->
              <div class="tc-row" *ngIf="c.isBubble" [class.run-first]="c.runFirst" [class.run-last]="c.runLast">
                <span class="tc-avatar-slot">
                  <img *ngIf="c.runLast && c.user_id" [src]="c.userPhotoUrl || 'assets/images/no_avatar.webp'" alt="" class="tc-avatar vb-click"
                       (click)="openViewer(c.userPhotoUrl)" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                </span>
                <div class="tc-bubble" [class.has-top-media]="c.hasPhotoOrVideo">
                  <div class="tc-quote" *ngIf="c.reply_to_id && !c.isDeleted">
                    <span class="tc-quote-name">{{c.quoteAuthor}}</span>
                    <span class="tc-quote-text">{{c.quoteText}}</span>
                  </div>
                  <img *ngIf="c.photo && !c.isDeleted" [src]="c.photo" alt="Foto" class="tc-photo vb-click" (click)="openViewer(c.photo)" loading="lazy">
                  <video *ngIf="c.video && !c.isDeleted" [src]="c.video" controls preload="metadata" class="tc-video"></video>
                  <div class="tc-body">
                    <div class="tc-name" *ngIf="c.runFirst && c.userName">{{c.userName}}</div>

                    <div class="tc-deleted" *ngIf="c.isDeleted" [title]="'Dihapus pengirim ' + c.deletedVw">
                      <i class="fa fa-ban"></i><span>Pesan ini dihapus</span><time class="tc-time">{{c.timeVw}}</time>
                    </div>

                    <a *ngIf="c.document && !c.isDeleted" class="tc-doc" [href]="c.document" target="_blank" rel="noopener" [title]="c.docName">
                      <span class="tc-doc-badge">{{fileExt(c.docName)}}</span><span class="tc-doc-name">{{c.docName}}</span>
                    </a>
                    <audio *ngIf="c.audio && !c.isDeleted" [src]="c.audio" controls preload="metadata" class="tc-audio"></audio>

                    <div class="tc-text" *ngIf="c.showText">{{c.text}}<span class="tc-meta-space"></span></div>
                    <div class="tc-meta" *ngIf="!c.isDeleted" [title]="c.timeFull">
                      <span *ngIf="c.isEdited" [title]="'Diedit ' + c.editedVw">diedit</span>{{c.timeVw}}
                    </div>
                    <button type="button" class="tc-del" *ngIf="canDelete && !c.isDeleted && c.user_id" (click)="askDeleteChat(c)"
                            title="Hapus pesan (khusus Super Admin)"><i class="fa fa-trash"></i></button>
                  </div>
                  <div class="tc-thread" *ngIf="c.reply_count && !c.isDeleted">
                    <button type="button" class="tc-thread-btn" (click)="toggleThread(c)">
                      <i class="fa" [ngClass]="thread(c).loading ? 'fa-spinner fa-spin' : (thread(c).open ? 'fa-chevron-up' : 'fa-comments')"></i>
                      {{formatNumber(c.reply_count)}} balasan
                    </button>
                    <div class="tc-replies" *ngIf="thread(c).open && thread(c).rows">
                      <div class="tc-reply" *ngFor="let r of thread(c).rows">
                        <img [src]="r.userPhotoUrl || 'assets/images/no_avatar.webp'" alt="" class="tc-avatar-sm" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                        <div class="tc-reply-bubble">
                          <div class="tc-name">{{r.userName}}</div>
                          <img *ngIf="r.photo" [src]="r.photo" alt="Foto" class="tc-photo small vb-click" (click)="openViewer(r.photo)" loading="lazy">
                          <video *ngIf="r.video" [src]="r.video" controls preload="metadata" class="tc-video small"></video>
                          <a *ngIf="r.document" class="tc-doc" [href]="r.document" target="_blank" rel="noopener"><span class="tc-doc-badge">{{fileExt(r.docName)}}</span><span class="tc-doc-name">{{r.docName}}</span></a>
                          <audio *ngIf="r.audio" [src]="r.audio" controls preload="metadata" class="tc-audio"></audio>
                          <div class="tc-text" *ngIf="r.showText">{{r.text}}</div>
                          <div class="tc-meta" [title]="r.timeFull">{{r.timeVw}}</div>
                        </div>
                      </div>
                      <div class="vl-muted vl-small" *ngIf="!thread(c).rows.length">Balasan sudah tidak ada</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- task day card (gold) -->
              <a href="javascript:;" class="tc-card gold" *ngIf="c.shape == 'task'" (click)="openTab('tasks')" title="Buka tab Tugas Bacaan">
                <span class="tc-card-ico gold"><i class="fa fa-book-open"></i></span>
                <span class="tc-card-text">
                  <span class="tc-card-label">{{c.cardLabel}}</span>
                  <span class="tc-card-title" *ngIf="c.cardBody">{{c.cardBody}}</span>
                </span>
                <time class="tc-time">{{c.timeVw}}</time>
              </a>

              <!-- announcement card (blue) -->
              <a href="javascript:;" class="tc-card blue" *ngIf="c.shape == 'announcement'" (click)="openTab('announcements')" title="Buka tab Pengumuman">
                <span class="tc-card-ico blue"><i class="fa fa-bullhorn"></i></span>
                <span class="tc-card-text">
                  <span class="tc-card-title-row"><span class="tc-card-title">{{c.cardLabel}}</span><time class="tc-time">{{c.timeVw}}</time></span>
                  <span class="tc-card-desc" *ngIf="c.cardBody">{{c.cardBody}}</span>
                </span>
              </a>

              <!-- per-juz celebration (green row card) -->
              <div class="tc-card green" *ngIf="c.shape == 'juz'" [title]="c.timeFull">
                <span class="tc-card-ico green"><i class="fa fa-check"></i></span>
                <span class="tc-card-text"><span class="tc-card-body" [innerHTML]="c.chipHtml"></span></span>
              </div>

              <!-- khatam (gold trophy card, centered) -->
              <div class="tc-hero gold" *ngIf="c.shape == 'khatam'" [title]="c.timeFull">
                <span class="tc-hero-ico gold"><i class="fa fa-trophy"></i></span>
                <span class="tc-hero-text" [innerHTML]="c.chipHtml"></span>
              </div>

              <!-- khatam reset (blue hero card) -->
              <div class="tc-hero blue" *ngIf="c.shape == 'reset'" [title]="c.timeFull">
                <span class="tc-hero-ico blue"><i class="fa fa-redo"></i></span>
                <span class="tc-hero-text" [innerHTML]="c.chipHtml"></span>
              </div>

              <!-- reassign (purple hero card) -->
              <div class="tc-hero purple" *ngIf="c.shape == 'reassign'" [title]="c.timeFull">
                <span class="tc-hero-ico purple"><i class="fa fa-exchange-alt"></i></span>
                <span class="tc-hero-text" [innerHTML]="c.chipHtml"></span>
              </div>

              <!-- passive system chip (joined / removed / task done / group deleted) -->
              <div class="tc-sys" *ngIf="c.shape == 'chip'" [title]="c.timeFull">
                <span class="tc-sys-chip" [ngClass]="c.chipTone"><i class="fa" [ngClass]="c.chipIcon"></i><span [innerHTML]="c.chipHtml"></span></span>
              </div>
            </ng-container>

            <div class="vl-empty" *ngIf="!chats.length && !chatsLoading">Belum ada percakapan di grup ini</div>
          </div>
        </div>

        <!-- ---------- HARI BACAAN ---------- -->
        <div class="vl-card" *ngIf="tab == 'tasks'">
          <div class="vl-loading" *ngIf="loading.tasks"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <div class="td-subbar">
            <label class="td-cycle">Siklus
              <select class="vl-select" (change)="setTaskCycle($event.target.value)">
                <option *ngFor="let c of group.cycles" [value]="c" [selected]="c == taskCycle">Khatam ke-{{c}}<ng-container *ngIf="c == group.current_cycle"> (berjalan)</ng-container></option>
              </select>
            </label>
            <div class="vl-spacer"></div>
            <span class="vl-muted vl-small">Klik hari untuk melihat bagian setiap anggota</span>
          </div>
          <div class="vl-scroll">
          <table class="vl-table">
            <thead><tr>
              <th class="vl-num">Giliran</th><th>Tanggal</th><th>Rentang Bacaan</th><th>Juz</th><th>Bagian Selesai</th><th>Status</th>
              <th *ngIf="canDelete" class="td-act-col"></th>
            </tr></thead>
            <tbody>
            <ng-container *ngFor="let t of tasks; let i = index">
              <tr class="vl-row tl-rowlink" [class.vl-alt]="i % 2 == 1" (click)="toggleTask(t)">
                <th class="vl-num td-day">{{turnTag(t.day, false)}} <span class="vl-chev" [class.open]="taskOpen[t.id]"><i class="fa fa-chevron-right"></i></span></th>
                <td>{{t.dateVw}}</td>
                <td>{{t.range_text}}</td>
                <td class="vl-muted">{{t.juzVw || '—'}}</td>
                <td><div class="td-part"><span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="t.pct"></span></span><span>{{t.parts_done}}/{{t.parts_total}}</span></div></td>
                <td>
                  <span class="vl-pill" [class.on]="t.isDone" [class.wait]="!t.isDone"><span class="vl-dot"></span>{{t.isDone ? 'Tuntas' : (t.parts_done ? 'Berjalan' : 'Belum ada yang baca')}}</span>
                </td>
                <td *ngIf="canDelete" class="td-act-col">
                  <button type="button" class="td-del" *ngIf="!group.deleted_at" (click)="askDeleteTask(t, $event)" title="Hapus tugas bacaan"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
              <tr *ngIf="taskOpen[t.id]" class="td-child">
                <td [attr.colspan]="canDelete ? 7 : 6">
                  <table class="td-sub">
                    <tr *ngFor="let d of t.details">
                      <td class="td-sub-user">
                        <img [src]="d.photoUrl || 'assets/images/no_avatar.webp'" alt="" class="td-avatar" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                        <span>{{d.user_name || 'Akun tidak ditemukan'}}</span>
                      </td>
                      <td>{{d.range_text}}</td>
                      <td class="vl-muted">{{d.begin_juz == d.end_juz ? 'Juz ' + d.begin_juz : 'Juz ' + d.begin_juz + '–' + d.end_juz}}</td>
                      <td class="text-right">
                        <span *ngIf="d.status == 1" class="td-done"><i class="fa fa-check-circle"></i> Selesai <span class="vl-muted" *ngIf="d.doneVw">&middot; {{d.doneVw}}</span></span>
                        <span *ngIf="d.status != 1" class="vl-muted"><i class="fa fa-clock"></i> Belum dibaca</span>
                      </td>
                    </tr>
                    <tr *ngIf="!t.details.length"><td colspan="4" class="vl-muted">Hari ini belum punya pembagian bagian</td></tr>
                  </table>
                </td>
              </tr>
            </ng-container>
            <tr *ngIf="!tasks.length && !loading.tasks"><td [attr.colspan]="canDelete ? 7 : 6" class="vl-empty">Belum ada tugas bacaan pada siklus ini</td></tr>
            </tbody>
          </table>
          </div>
          <div class="vl-foot">
            <span class="vl-summary">Menampilkan <b>{{formatNumber(rangeFrom(tasksPage, tasksTotal))}}&ndash;{{formatNumber(rangeTo(tasksPage, tasks.length))}}</b> dari <b>{{formatNumber(tasksTotal)}}</b> tugas</span>
            <div class="vl-spacer"></div>
            <nav class="vl-pager" aria-label="Navigasi tugas bacaan">
              <button type="button" class="vl-page" [disabled]="tasksPage == 1" (click)="goTasksPage(tasksPage - 1)">&lsaquo;</button>
              <ng-container *ngFor="let p of tasksPages">
                <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == tasksPage" (click)="goTasksPage(p)">{{p}}</button>
              </ng-container>
              <button type="button" class="vl-page" [disabled]="tasksPage == pagesOf(tasksTotal)" (click)="goTasksPage(tasksPage + 1)">&rsaquo;</button>
            </nav>
          </div>
        </div>

        <!-- ---------- PROGRES ---------- -->
        <div class="vl-card" *ngIf="tab == 'progress'">
          <div class="vl-loading" *ngIf="loading.progress"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <div class="td-subbar">
            <label class="td-cycle">Siklus
              <select class="vl-select" (change)="setProgressCycle($event.target.value)">
                <option *ngFor="let c of group.cycles" [value]="c" [selected]="c == progressCycle">Khatam ke-{{c}}<ng-container *ngIf="c == group.current_cycle"> (berjalan)</ng-container></option>
              </select>
            </label>
            <div class="vl-spacer"></div>
            <ng-container *ngIf="progress">
              <span class="td-legend"><i class="complete"></i> Tuntas bersama ({{progress.completeCount}})</span>
              <span class="td-legend"><i class="partial"></i> Sedang dibaca ({{progress.partialCount}})</span>
              <span class="td-legend"><i class="untouched"></i> Belum</span>
            </ng-container>
          </div>
          <ng-container *ngIf="progress">
            <div class="td-juz">
              <span *ngFor="let j of progress.juz" class="td-juz-cell" [ngClass]="j.state" [title]="juzTitle(j)">{{j.juz}}</span>
            </div>
            <div class="td-prog-sum">
              <span><b>{{formatNumber(progress.days)}}</b> tugas bacaan</span>
              <span><b>{{formatNumber(progress.parts_done)}}</b> dari <b>{{formatNumber(progress.parts_total)}}</b> bagian selesai ({{progress.pct}}%)</span>
              <span *ngIf="progress.current_juz">posisi terjauh <b>Juz {{progress.current_juz}}</b></span>
              <span class="td-chip gold" *ngIf="progress.is_khatam_complete"><i class="fa fa-flag-checkered"></i> Khatam tercapai</span>
            </div>
            <div class="vl-scroll">
            <table class="vl-table">
              <thead><tr><th class="vl-num">No</th><th>Anggota</th><th>Bagian</th><th>Selesai</th><th style="width: 32%">Capaian</th><th>Terakhir Selesai</th></tr></thead>
              <tbody>
              <tr *ngFor="let m of progress.members; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
                <th class="vl-num">{{i + 1}}</th>
                <td><div class="tl-ident"><img [src]="m.photoUrl || 'assets/images/no_avatar.webp'" alt="" class="td-avatar-md" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';"><span class="vl-name">{{m.nameVw}}</span></div></td>
                <td>{{formatNumber(m.parts_total)}}</td>
                <td>{{formatNumber(m.parts_done)}}</td>
                <td><div class="td-part wide"><span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="m.pct"></span></span><span>{{m.pct}}%</span></div></td>
                <td class="vl-muted">{{m.lastDoneVw}}</td>
              </tr>
              <tr *ngIf="!progress.members.length"><td colspan="6" class="vl-empty">Belum ada pembagian bagian pada siklus ini</td></tr>
              </tbody>
            </table>
            </div>
          </ng-container>
        </div>

        <!-- ---------- AKTIVITAS ---------- -->
        <div class="vl-card" *ngIf="tab == 'activity'">
          <div class="vl-loading" *ngIf="loading.activity"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <div class="td-subbar">
            <select class="vl-select" aria-label="Filter jenis aktivitas" [value]="actKind" (change)="setActKind($event.target.value)">
              <option value="">Semua jenis</option>
              <option *ngFor="let k of kinds()" [value]="k">{{kindMeta(k).label}}</option>
            </select>
            <div class="vl-spacer"></div>
            <span class="vl-muted vl-small">Kejadian sistem saja &mdash; percakapan anggota ada di tab Percakapan</span>
          </div>
          <ul class="tl-feed">
            <li *ngFor="let a of act" class="tl-feed-row">
              <span class="tl-feed-ico" [ngClass]="a.meta.tone"><i class="fa" [ngClass]="a.meta.icon"></i></span>
              <div class="tl-feed-body">
                <div class="tl-feed-text">{{a.textVw}}</div>
                <div class="tl-feed-meta">
                  <span class="vl-tag kind">{{a.meta.label}}</span>
                  <span *ngIf="a.reply_count">{{a.reply_count}} balasan</span>
                  <a *ngIf="a.photo" href="javascript:;" (click)="openViewer(a.photo)"><i class="fa fa-image"></i> Foto</a>
                  <a *ngIf="a.video" [href]="a.video" target="_blank" rel="noopener"><i class="fa fa-video"></i> Video</a>
                  <a *ngIf="a.audio" [href]="a.audio" target="_blank" rel="noopener"><i class="fa fa-microphone"></i> Audio</a>
                  <a *ngIf="a.document" [href]="a.document" target="_blank" rel="noopener"><i class="fa fa-file"></i> Dokumen</a>
                </div>
              </div>
              <time class="tl-feed-time" [title]="a.timeFull">{{a.timeVw}}</time>
            </li>
            <li *ngIf="!act.length && !loading.activity" class="vl-empty">Belum ada aktivitas</li>
          </ul>
          <div class="vl-foot">
            <span class="vl-summary">Menampilkan <b>{{formatNumber(rangeFrom(actPage, actTotal))}}&ndash;{{formatNumber(rangeTo(actPage, act.length))}}</b> dari <b>{{formatNumber(actTotal)}}</b> aktivitas</span>
            <div class="vl-spacer"></div>
            <nav class="vl-pager" aria-label="Navigasi aktivitas">
              <button type="button" class="vl-page" [disabled]="actPage == 1" (click)="goActPage(actPage - 1)">&lsaquo;</button>
              <ng-container *ngFor="let p of actPages">
                <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == actPage" (click)="goActPage(p)">{{p}}</button>
              </ng-container>
              <button type="button" class="vl-page" [disabled]="actPage == pagesOf(actTotal)" (click)="goActPage(actPage + 1)">&rsaquo;</button>
            </nav>
          </div>
        </div>

        <!-- ---------- PENGUMUMAN ---------- -->
        <div class="vl-card" *ngIf="tab == 'announcements'">
          <div class="vl-loading" *ngIf="loading.announcements"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <ul class="td-ann">
            <li *ngFor="let a of ann" class="td-ann-row">
              <div class="td-ann-head">
                <span class="td-ann-title">{{a.text}}</span>
                <span class="vl-spacer"></span>
                <time class="vl-muted vl-small">{{a.dateVw}}</time>
                <button type="button" class="td-del" *ngIf="canDelete" (click)="askDeleteAnnouncement(a)" title="Hapus pengumuman"><i class="fa fa-trash"></i></button>
              </div>
              <p class="td-ann-body" *ngIf="a.description">{{a.description}}</p>
              <div class="td-ann-read">
                <span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="a.readPct"></span></span>
                <span class="vl-muted vl-small">dibaca {{formatNumber(a.read_count)}} dari {{formatNumber(a.active_members)}} anggota aktif</span>
              </div>
            </li>
            <li *ngIf="!ann.length && !loading.announcements" class="vl-empty">Belum ada pengumuman</li>
          </ul>
          <div class="vl-foot">
            <span class="vl-summary">Menampilkan <b>{{formatNumber(rangeFrom(annPage, annTotal))}}&ndash;{{formatNumber(rangeTo(annPage, ann.length))}}</b> dari <b>{{formatNumber(annTotal)}}</b> pengumuman</span>
            <div class="vl-spacer"></div>
            <nav class="vl-pager" aria-label="Navigasi pengumuman">
              <button type="button" class="vl-page" [disabled]="annPage == 1" (click)="goAnnPage(annPage - 1)">&lsaquo;</button>
              <ng-container *ngFor="let p of annPages">
                <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == annPage" (click)="goAnnPage(p)">{{p}}</button>
              </ng-container>
              <button type="button" class="vl-page" [disabled]="annPage == pagesOf(annTotal)" (click)="goAnnPage(annPage + 1)">&rsaquo;</button>
            </nav>
          </div>
        </div>

        <!-- ---------- RIWAYAT KHATAM ---------- -->
        <div class="vl-card" *ngIf="tab == 'khatam'">
          <div class="vl-loading" *ngIf="loading.khatam"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <div class="vl-scroll">
          <table class="vl-table">
            <thead><tr><th class="vl-num">Siklus</th><th>Mulai</th><th>Selesai</th><th>Durasi</th><th class="text-center">Tugas Bacaan</th><th>Peserta</th></tr></thead>
            <tbody>
            <tr *ngFor="let c of khatam; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
              <th class="vl-num td-day">Khatam ke-{{c.cycle}}</th>
              <td>{{c.startedVw}}</td>
              <td>{{c.completedVw}}</td>
              <td class="vl-muted">{{c.durationVw || '—'}}</td>
              <td class="text-center">{{formatNumber(c.total_days)}}</td>
              <td>
                <div class="td-stack">
                  <img *ngFor="let m of c.members.slice(0, 8)" [src]="m.photoUrl || 'assets/images/no_avatar.webp'" [title]="m.name" alt="" class="td-avatar"
                       onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                  <span class="vl-muted vl-small" *ngIf="c.members.length > 8">+{{c.members.length - 8}}</span>
                  <span class="vl-muted vl-small">{{c.members.length}} peserta</span>
                </div>
              </td>
            </tr>
            <tr *ngIf="!khatam.length && !loading.khatam"><td colspan="6" class="vl-empty">Belum ada khatam yang diselesaikan &mdash; siklus berjalan ada di tab Progres</td></tr>
            </tbody>
          </table>
          </div>
        </div>

      </div>
    </div>
  </ng-container>
</div>

<app-confirm-delete *ngIf="del" [title]="del.title" [subject]="del.subject" [effects]="del.effects"
                    [confirmText]="del.confirmText" [actionLabel]="del.actionLabel" [busy]="deleting"
                    (confirm)="doDelete()" (cancel)="del = null"></app-confirm-delete>

<div class="vb-viewer" *ngIf="isViewer" (click)="closeViewer()">
  <img [src]="isViewer" alt="Foto">
  <button type="button" class="vb-viewer-close" title="Tutup" aria-label="Tutup">&times;</button>
</div>
